// extracted by mini-css-extract-plugin
module.exports = {"overviewContainer":"Home_overviewContainer__3bA8C","overview":"Home_overview__3mUEB","overviewParagraph":"Home_overviewParagraph__klwBs","header":"Home_header__37EqS"};